var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackgroundEraser = function SvgBackgroundEraser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "#FEA832"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5298)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.2653,
    cy: 88.6735,
    r: 16.8367,
    fill: "#FFF4E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.6531,
    cy: 47.1428,
    r: 5.61224,
    fill: "#FFE3E6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.143 76.431C102.143 73.1003 99.4437 70.4011 96.113 70.4011H74.1861C70.8554 70.4011 68.1562 73.1003 68.1562 76.431V98.3579C68.1562 101.689 70.8554 104.388 74.1861 104.388H96.113C99.4437 104.388 102.143 101.689 102.143 98.3579V76.431ZM98.8538 76.431V98.3579C98.8538 99.8708 97.6259 101.099 96.113 101.099H74.1861C72.6731 101.099 71.4452 99.8708 71.4452 98.3579V76.431C71.4452 74.918 72.6731 73.6901 74.1861 73.6901H96.113C97.6259 73.6901 98.8538 74.918 98.8538 76.431Z",
    fill: "url(#paint0_linear_1112_5298)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9635 84.7873L59.6726 91.0782C60.109 91.179 60.5629 91.2317 61.0299 91.2317H65.9635V84.7873ZM66.6498 73.1376L55 84.7873V85.2018C55 86.8331 55.6468 88.3132 56.6993 89.3986L65.9635 80.1344V76.431C65.9635 75.2601 66.209 74.144 66.6498 73.1376V73.1376ZM77.8895 57.2449L55 80.1344V73.8239L71.5789 57.2449H77.8895ZM66.926 57.2449H61.0299C57.6992 57.2449 55 59.9441 55 63.2748V69.171L66.926 57.2449ZM70.8926 68.8947C71.8991 68.454 73.0152 68.2084 74.1861 68.2084H77.8895L87.1536 58.9443C86.0682 57.8918 84.5882 57.2449 82.9568 57.2449H82.5424L70.8926 68.8947ZM82.5424 68.2084H88.9867V63.2748C88.9867 62.8078 88.9341 62.3539 88.8332 61.9176L82.5424 68.2084Z",
    fill: "url(#paint1_linear_1112_5298)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5298",
    x1: 102.143,
    y1: 70.4011,
    x2: 68.1562,
    y2: 70.4011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5298",
    x1: 88.9867,
    y1: 57.2449,
    x2: 55,
    y2: 57.2449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundEraser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background-eraser.af915a1182534068aca5d98aab99aba3.svg";